/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PartnerExperienceType = {
    TOURNAMENT: 'TOURNAMENT',
    QUEST: 'QUEST',
    LEADERBOARD: 'LEADERBOARD',
    DROP: 'DROP'
} as const;
export type PartnerExperienceType = typeof PartnerExperienceType[keyof typeof PartnerExperienceType];


export function instanceOfPartnerExperienceType(value: any): boolean {
    for (const key in PartnerExperienceType) {
        if (Object.prototype.hasOwnProperty.call(PartnerExperienceType, key)) {
            if (PartnerExperienceType[key as keyof typeof PartnerExperienceType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PartnerExperienceTypeFromJSON(json: any): PartnerExperienceType {
    return PartnerExperienceTypeFromJSONTyped(json, false);
}

export function PartnerExperienceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerExperienceType {
    return json as PartnerExperienceType;
}

export function PartnerExperienceTypeToJSON(value?: PartnerExperienceType | null): any {
    return value as any;
}

export function PartnerExperienceTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): PartnerExperienceType {
    return value as PartnerExperienceType;
}

